export default function Numpy_ArraySort() {
  return <div>Numpy_ArraySort Component</div>;
}
